import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BonusComponent } from './bonus.component';
import { BonusModule } from './bonus.module';
import { PermanentComponent } from './permanent/permanent.component';
import { BonusHistoryComponent } from './permanent/bonus-history/bonus-history.component';
import { BonusSettingComponent } from './promotion/bonus-setting/bonus-setting.component';

const routes: Routes = [
  {
    path: '',
    component: BonusComponent,
    children: [
      { path: '', redirectTo: 'permanent', pathMatch: 'full' },
      {
        path: 'permanent',
        component: PermanentComponent,
      },
      {
        path: 'manual',
        component: BonusHistoryComponent,
      },
      {
        path: 'promotion',
        component: BonusSettingComponent,
      },
    ],
  },
];
export const routing: ModuleWithProviders<BonusModule> =
  RouterModule.forChild(routes);
